import { useContext, useEffect } from 'react';
import { GlobalAlertContext } from 'utilities/GlobalContext/GlobalAlert';
import { GlobalConfirmContext } from 'utilities/GlobalContext/GlobalConfirm';

type Props = {
  refs?: any[];
  handler: (e: any) => void;
  condition?: boolean;
};

export function useOnClickOutside({ refs, handler, condition = true }: Props) {
  const { alert } = useContext(GlobalAlertContext);
  const { confirm } = useContext(GlobalConfirmContext);

  useEffect(() => {
    if (condition && !alert && !confirm) {
      const listener = (event: MouseEvent | TouchEvent | KeyboardEvent) => {
        // check for keydown events so that we can also fire based on tab-key being pressed
        if (event.type === 'keydown') {
          if (
            !refs?.length ||
            refs?.find((r) => r?.current?.contains(event?.target))
          ) {
            if (event?.key === 'Tab') {
              handler(event);
            }
          }
        } else {
          // otherwise we use the old code that Roland wrote
          if (
            !refs?.length ||
            refs?.find((r) => r?.current?.contains(event?.target)) !== undefined
          )
            return;

          handler(event);
        }
      };

      document.addEventListener('mousedown', listener);
      document.addEventListener('keydown', listener);

      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('keydown', listener);
      };
    }
  }, [refs, handler, condition]);
}
